// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import CaptionFormController from "./caption_form_controller"
application.register("caption-form", CaptionFormController)
import CaptionButtonController from "./caption_button_controller"
application.register("caption-button", CaptionButtonController)
import RowActionController from "./row_action_controller"
application.register("row-action", RowActionController)
import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)
import VisitOnLoadController from "./visit_on_load_controller"
application.register("visit-on-load", VisitOnLoadController)
import AutofocusController from "./autofocus_controller"
application.register("auto-focus", AutofocusController)
import ThemeController from "./theme_controller"
application.register("theme-controller", ThemeController)
import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)
import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)
import HeavyOperationController from "./heavy_operation_controller"
application.register("heavy-operation", HeavyOperationController)